import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { NP_API_URL, NP_SEARCH_DEBOUNCE_MS } from '../../utils/novaPostApi';
import { useNovaPostDeliveryCityRef } from '../../hooks/useNovaPostDeliveryCityRef';

const NovaPostAddressInput = ({
                                street,
                                buildingNumber, flatNumber,
                                onStreetChange,
                                onBuildingNumberChange,
                                onFlatNumberChange,
                                novaPostCityRef,
                                novaPostDeliveryCityRef,
                                cityName,
                                streetInputClassName,
                                buildingNumberInputClassName
                              }) => {
  const [streetSuggestions, setStreetSuggestions] = useState([]);
  const [showStreetSuggestions, setShowStreetSuggestions] = useState(false);
  const searchTimerRef = useRef(null);
  const searchRequestIdRef = useRef(0);

  const { cityRef, isResolving } = useNovaPostDeliveryCityRef({
    cityName,
    novaPostCityRef,
    novaPostDeliveryCityRef,
  });

  useEffect(() => {
    setStreetSuggestions([]);
    setShowStreetSuggestions(false);
    return () => {
      if (searchTimerRef.current) clearTimeout(searchTimerRef.current);
      searchRequestIdRef.current += 1;
    };
  }, [cityRef]);

  const searchStreets = (query) => {
    if (!cityRef) return;

    const requestId = ++searchRequestIdRef.current;

    axios
      .post(NP_API_URL, {
        modelName: 'AddressGeneral',
        calledMethod: 'getStreet',
        methodProperties: {
          FindByString: query,
          CityRef: cityRef,
        },
      })
      .then((response) => {
        if (requestId !== searchRequestIdRef.current) return;
        if (response.data.success) {
          const streets = (response.data.data || []).map((streetItem) => ({
            present: `${streetItem.StreetsType} ${streetItem.Description}`,
            ref: streetItem.Ref,
          }));
          setStreetSuggestions(streets);
        } else {
          setStreetSuggestions([]);
        }
      })
      .catch((error) => {
        if (requestId !== searchRequestIdRef.current) return;
        setStreetSuggestions([]);
        console.error('Error fetching streets:', error);
      });
  };

  const handleStreetChange = (e) => {
    const inputValue = e.target.value;
    onStreetChange({ street: inputValue });

    if (searchTimerRef.current) clearTimeout(searchTimerRef.current);
    searchRequestIdRef.current += 1;
    setStreetSuggestions([]);

    if (inputValue.length >= 2) {
      setShowStreetSuggestions(true);
      searchTimerRef.current = setTimeout(() => searchStreets(inputValue), NP_SEARCH_DEBOUNCE_MS);
    } else {
      setShowStreetSuggestions(false);
    }
  };

  const handleSuggestionClick = (suggestion) => {
    if (searchTimerRef.current) clearTimeout(searchTimerRef.current);
    searchRequestIdRef.current += 1;
    onStreetChange({ street: suggestion.present, ref: suggestion.ref});
    setShowStreetSuggestions(false);
  };

  const handleBuildingNumberChange = (e) => {
    onBuildingNumberChange(e.target.value);
  };

  const handleFlatNumberChange = (e) => {
    onFlatNumberChange(e.target.value);
  };

  return (
    <div className='mb-3'>
      <div className='row'>
        <div className='col-8 pr-1'>
          <input
            type='search'
            className={streetInputClassName ? streetInputClassName : 'form-control'}
            name='street'
            placeholder={!cityRef || isResolving ? 'Спочатку оберіть місто' : 'Введіть назву вулиці'}
            onChange={handleStreetChange}
            value={street || ''}
            autoComplete='new-password'
            disabled={!cityRef || isResolving}
          />
          {showStreetSuggestions && (
            <ul className='list-group' style={{ maxHeight: '200px', overflowY: 'auto' }}>
              {streetSuggestions.map((suggestion, index) => (
                <li
                  key={index}
                  className='list-group-item'
                  onClick={() => handleSuggestionClick(suggestion)}
                  style={{ cursor: 'pointer' }}
                  onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#e9ecef'}
                  onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#fff'}
                >
                  {suggestion.present}
                </li>
              ))}
            </ul>
          )}
        </div>
        <div className='col-2 px-1'>
          <input
            type='text'
            className={buildingNumberInputClassName ? buildingNumberInputClassName : 'form-control'}
            name='house'
            placeholder='Будинок'
            onChange={handleBuildingNumberChange}
            value={buildingNumber || ''}
            autoComplete='new-password'
            disabled={!cityRef || isResolving}
          />
        </div>
        <div className='col-2 pl-1'>
          <input
            type='text'
            className='form-control'
            name='apartment'
            placeholder='Квартира'
            onChange={handleFlatNumberChange}
            value={flatNumber || ''}
            autoComplete='new-password'
            disabled={!cityRef || isResolving}
          />
        </div>
      </div>
    </div>
  );
};

export default NovaPostAddressInput;
